;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('ArtStatusBadgeController', ArtStatusBadgeController)

  /* @ngInject */
  function ArtStatusBadgeController ($timeout) {
    activate()

    function activate () {
      $timeout(() => {
        $('.unarchive-tooltip').popup({})
      }, 250, false)
    }
  }
})()
